'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHoc = require('@mindz/react-hoc');

var _CheckboxDefaultModule = require('./Checkbox.default.module.css');

var _CheckboxDefaultModule2 = _interopRequireDefault(_CheckboxDefaultModule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var generateUUID = function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};

var CheckboxDefault = function (_Component) {
  _inherits(CheckboxDefault, _Component);

  function CheckboxDefault() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CheckboxDefault);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CheckboxDefault.__proto__ || Object.getPrototypeOf(CheckboxDefault)).call.apply(_ref, [this].concat(args))), _this), _this.renderError = function () {
      var _this$props = _this.props,
          cx = _this$props.cx,
          error = _this$props.error;

      if (!error) {
        return null;
      }

      if (Array.isArray(error)) {
        return _react2.default.createElement('div', {
          className: cx('error', {
            shown: _this.hasError()
          })
        }, error[0]);
      }

      return _react2.default.createElement('div', {
        className: cx('error', {
          shown: _this.hasError()
        })
      }, error);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CheckboxDefault, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cx = _props.cx,
          id = _props.id,
          name = _props.name,
          value = _props.value,
          children = _props.children,
          handleChange = _props.handleChange,
          isLink = _props.isLink,
          isDisabled = _props.isDisabled,
          isCard = _props.isCard,
          imageUrl = _props.imageUrl;
      return _react2.default.createElement('div', {
        onClick: function onClick() {
          return !isDisabled && handleChange && handleChange();
        },
        className: cx('root', {
          noText: !children,
          isChecked: value,
          isLink: isLink,
          isDisabled: isDisabled,
          isCard: isCard
        })
      }, _react2.default.createElement('span', null, _react2.default.createElement('span', null), _react2.default.createElement('span', null)), _react2.default.createElement('label', {
        className: cx('label'),
        onClick: function onClick() {},
        htmlFor: id
      }, !isLink && _react2.default.createElement('span', null, _react2.default.createElement('input', {
        type: 'hidden',
        name: name,
        value: 'False'
      }), _react2.default.createElement('input', {
        type: 'checkbox',
        name: name,
        id: id,
        checked: value,
        onChange: function onChange() {},
        value: 'True'
      })), isCard && _react2.default.createElement('div', {
        className: cx('image-wrapper')
      }, imageUrl && _react2.default.createElement('img', {
        src: imageUrl,
        alt: 'brand-logo'
      })), children), this.renderError());
    }
  }, {
    key: 'hasError',
    value: function hasError() {
      var error = this.props.error;
      return !!error;
    }
  }]);

  return CheckboxDefault;
}(_react.Component);

CheckboxDefault.defaultProps = {
  handleChange: function handleChange() {},
  id: 'id-' + generateUUID()
};
CheckboxDefault.propTypes = {
  id: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.bool.isRequired,
  handleChange: _propTypes2.default.func.isRequired
};
exports.default = (0, _reactHoc.withStyles)(_CheckboxDefaultModule2.default)(CheckboxDefault);
module.exports = exports.default;